import "../assets/styles/components/document-card.scss";
import Document from "../assets/icons/document";
import { download_document } from "../utils/endpoints";
import CloseRounded from "../assets/icons/close-rounded";
import DocumentDelete from "./modal-contents/DocumentDelete";
import Image from "../assets/icons/image";

export default function DocumentCard({
  document_info,
  context,
  openFile,
  loadAttachmentList,
  role,
}) {
  const handleOpenDocument = async (attachment) => {
    let response = await context.httpRequest(
      "get",
      download_document.replace("*", attachment.id),
      null,
      context.session.token
    );
    if (response.result) {
      if (attachment.attachmentType === "PHOTO")
        openFile(attachment, response.data.presignedUrl);
      else downloadFile(attachment, response.data.presignedUrl);
    }
  };

  const downloadFile = async (attachment, file_url) => {
    const response = await fetch(file_url);
    const blobImage = await response.blob();
    const href = URL.createObjectURL(blobImage);
    const anchorElement = document.createElement("a");
    anchorElement.href = href;
    anchorElement.download = attachment.name;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
  };

  const handleDelete = () => {
    context.openModal(
      <DocumentDelete
        document_info={document_info}
        context={context}
        loadAttachmentList={loadAttachmentList}
      />
    );
  };

  if (document_info) {
    return (
      <div className="document-card d-flex align-items-center p-2 overflow-hidden mb-3 mx-md-auto border shadow-sm position-relative">
        <div
          className="d-flex align-items-center"
          onClick={() => handleOpenDocument(document_info[0].attachment)}
        >
          <div className="d-flex align-items-center justify-content-center border me-3 p-3">
            {document_info[0].attachment.attachmentType === "PHOTO" ? (
              <Image size={40} color="#20419a" />
            ) : (
              <Document size={40} color="#20419a" />
            )}
          </div>

          <div className="document-info w-100">
            <strong className="d-block">
              {document_info[0].attachment.name}
            </strong>
            <small className="mt-2 mb-1 d-block">
              Punti vendita associati:
            </small>
            <div className="d-flex flex-wrap">
              {document_info.map((item, index) => {
                return (
                  <small key={index} className="pv-label py-1 px-2 me-1">
                    <div className="tooltip-component">
                      <div className="tooltip-text tooltip-top">
                        <small className="d-block">
                          {`${item.pv.pv.indirizzo}, ${item.pv.pv.comune} (${item.pv.pv.prov})`}
                        </small>
                      </div>
                      {item.pv.pv.codicePv}
                    </div>
                  </small>
                );
              })}
            </div>
          </div>
        </div>
        {!["GESTORE"].includes(role) ? (
          <CloseRounded
            onClick={() => handleDelete()}
            className="ms-auto"
            size={24}
          />
        ) : null}
      </div>
    );
  }
}
